import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnChanges,
  Inject,
  ElementRef,
  HostListener,
  OnDestroy,
  TemplateRef,
  LOCALE_ID,
} from "@angular/core";
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { AuthenticationComponent } from 'src/app/authentication/authentication.component';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ApiService } from 'src/app/pages/common/api.service';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { SpecialProjectCheck } from 'src/app/shared/services/common/special-project-check';
import { Location,DOCUMENT } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SearchComponent } from './search-modal/search-modal.component';
import { AddCardModalComponent } from 'src/app/authentication/addCard-modal/addCard-modal.component';
import { CountryModalComponent } from 'src/app/shared/components/country-modal/country-modal.component';
import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';
import { ToastrService } from 'ngx-toastr';
import { DetectLocation } from 'src/app/shared/services/common/detect-location.service';
import { Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { Country, CountryData } from "../../interfaces";

export interface ILanguage {
  attributes: {
    code: string,
    id: string,
    iso639_1: string,
    name: string
  },
  id: string,
  type: string
}

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss'],
  providers: [ApiService, GlobalConstants]
})
export class HeaderComponent implements OnInit, OnChanges,OnDestroy {
  projectSubscription: Subscription;
  @Input() showProfileDropDown: any = false;
  @Input() showAuthentication: boolean = false;
  @Output() hideProfileDropDown = new EventEmitter<any>();

  @Output() reloadTemplate = new EventEmitter();
  @Input() refreshHeader: boolean = false;
  @Input() milestoneRewardsExists: boolean = false;
  @Input() selectedCategory;
  @ViewChild(AuthenticationComponent) authC: AuthenticationComponent;
  modalRef;
  IDLE_TIMEOUT = 900;
  _idleSecondsTimer = null;
  _idleSecondsCounter = 0;
  // showAuthentication: any = false;
  openHamburger = false;
  deviceInfo = null;
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktopDevice: boolean = false;
  isLoggedIn: boolean = false;
  modalOpen: any = false;
  openMenu: any = false;
  openMenuMob: any = false;
  modalOpenMob: any = false;
  userCards: any = [];

  hideHeader: boolean = false;
  public templateNum: number = 1;
  currentUserCard: any;

  activeCardType: any;
  environment_type: any;
  specialProject: any;
  innerPage = false;

  temp2SearchOpen = false;
  isSearchDropdownOpen = false;
  // selectedCat = '';
  searchInput: string = '';
  private subject: Subject<string> = new Subject();
  searching: boolean = false;
  searchLoading: boolean = false;
  showNull: boolean;
  merchantList = [];
  private subscriptions: Subscription[] = []
  locationData: any;
  ipCountry: any;
  public selectedLanguage: ILanguage;
  private languages: ILanguage[] = [];
  public filteredLanguages: ILanguage[] = [];
  @Output() selectedlocationId = new EventEmitter<string>();
  @ViewChild('countryModal') countryModal:TemplateRef<any>;
  openCountryModal: boolean = false;
  searchControl = new UntypedFormControl('');
  @HostListener('unloaded')
  ngOnDestroy() {
    this.dataTransferService.nextMessage(null)
    if(this.projectSubscription){
      this.projectSubscription.unsubscribe()
    }
    this.elementRef.nativeElement.remove();

    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });;
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (window.innerWidth > 1024) {
      this.isDesktopDevice = true;
      this.isTablet = false;
      this.isMobile = false;
      // this.ngOnInit();
    }
    else if (window.innerWidth > 768) {
      this.isDesktopDevice = false;
      this.isTablet = true;
      this.isMobile = false;
      // this.ngOnInit();
    }
    else {
      this.isDesktopDevice = false;
      this.isTablet = false;
      this.isMobile = true;
      // this.ngOnInit();
    }
    // this.innerWidth = window.innerWidth;
  }
  constructor(
    private router: Router,
    public _apiService: ApiService,
    public GlobalConstants: GlobalConstants,
    private authenticationService: AuthenticationService,
    private dataTransferService: DataTransferService,
    private location: Location,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    @Inject(DOCUMENT) private document: any,
    private toastr: ToastrService,
    private elementRef: ElementRef,
    public SpecialProjectCheck: SpecialProjectCheck,
    private _detectLocation: DetectLocation,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.onResize();
    this.environment_type = this.document.location.hostname.includes("sandbox") ? 'sandbox' : 'prod';
    let pathname = this.document.location.pathname.split('/',3);
    this.innerPage = (pathname[1] && pathname[1] != '') ? true : false;
    this.getCountries()
    this.getLanguages()

  }
  ngOnInit() {
    this.checkAuth();
    this.checkCountry();
    this.getInternationalGeoLocation();

    this.dataTransferService.sharedReloadEvent.subscribe(res => {
      if(res){
        this.checkAuth();
        this.checkCountry();
      }
    });
    if(this.SpecialProjectCheck.checkProject().type === 'special'){
      this.specialProject= true;
    }
    else{
      this.specialProject= false;
    }
    this._detectLocation.getInternationalGeoLocation()
    // this.subject.pipe(
    //   debounceTime(300)
    // ).subscribe(searchTextValue => {
    //   // this.populateMerchantList(searchTextValue);

    // });
    this.searchSubscription();
  }

  getCountries() {
    let allCountries = JSON.parse(localStorage.getItem("allCountries") || "[]");
    if (!allCountries?.length) {
      this._apiService
        .getAllCountries()
        .subscribe((res: { data: Array<Country>; ip_country?: string }) => {
          this.allCountries = res?.data || [];
          localStorage.setItem("allCountries", JSON.stringify(res?.data || []));
          this.getCurrentCountry()
        });
    } else {
      this.allCountries = allCountries;
      this.getCurrentCountry()
    }
  }

  private getCurrentCountry(): void {
    if (!localStorage.getItem("userCountry")) {
      this._apiService.getCountryData().subscribe({
        next: (res: CountryData) => {
          const currentCountry = this.allCountries?.find(
            (country: Country) => country.attributes.iso2_code === res?.country
          );
          localStorage.setItem(
            "userCountry",
            JSON.stringify(currentCountry || {})
          );
        },
      });
    }
    this.processCountryData();
  }

  private processCountryData(){
    if (localStorage.getItem("locationData")) {
      this.locationData = JSON.parse(localStorage.getItem("locationData"));
    }
    else if (this.GlobalConstants.data.personalized_config.auto_location_detect) {
      this._apiService.getIpCountry().subscribe(
        (res: Array<any>) => {
          this.ipCountry = res;
          if (this.allCountries.find((x) => { return x.iso2_code == this.ipCountry.country_code })) {
            this.locationData = this.allCountries.find((x) => { return x.iso2_code == this.ipCountry.country_code });
            this.selectedlocationId.emit(this.locationData.id);
            localStorage.setItem("locationData", JSON.stringify(this.locationData));
          }
          else {
            this.modalRef = this.modalService.show(this.countryModal, { class: 'country-modal', backdrop: 'static' });
            this.openCountryModal = true;
          }
        }
      );
    }
  }
  getLanguages() {
    this._apiService.getAllLanguages().subscribe(
      ((res: {data: ILanguage[]}) => {
        this.languages = res?.data?.filter((language: ILanguage) => this._detectLocation.availableTranslatedLanguages?.includes(language?.attributes?.name?.toLowerCase()));
        this.filteredLanguages = this.languages;
        if (!this.selectedLanguage) {
          this.selectedLanguage = this.languages.find((language: ILanguage) => language?.attributes?.iso639_1 === this.locale)
          this.setLanguage(this.selectedLanguage);
        }
      }
      ))
  }

  setLanguage(lang, defaultCountryLang = false){
    this.selectedLanguage = { ...lang };
    this._detectLocation.setLanguage(this.selectedLanguage, defaultCountryLang);
  }


  locationChange(country){
    this.locationData = country;
    localStorage.setItem('locationData', JSON.stringify(country));
    this.selectedlocationId.emit(country.id);
    this.modalRef.hide();
  }

  checkCountry() {
    const storedCountry = localStorage.getItem('userCountry');
    if (storedCountry) {
      this.userCountry = JSON.parse(storedCountry)
      this.checkJapanLocale();
      if (!this.userCountry.attributes) {
        this.userCountry['attributes'] = this.userCountry;
      }
    }
  }

  checkAuth(){
    if (this.GlobalConstants.data.bin_login && localStorage.getItem("cb")) {
      this.isLoggedIn = true;
      this.getProjects();
      // this.getCards();
    } else {
      if (localStorage.getItem("currentUser")) {
        if ((this.locale === 'ja' || this.userCountry?.attributes?.iso2_code === 'JP') && !localStorage?.getItem('isJaToken')) {
          this.clearAuthStorage();
          this.isLoggedIn = false;
        } else if ((this.locale !== 'ja' && this.userCountry?.attributes?.iso2_code !== 'JP') && localStorage?.getItem('isJaToken')) {
          this.clearAuthStorage();
          this.isLoggedIn = false;
        } else {
          this.isLoggedIn = true;
          this.getProjects();
          this.getCards();
        }
      } else {
        this.clearAuthStorage()
        this.isLoggedIn = false;
      }
    }
    if (JSON.parse(localStorage.getItem('card_verified')) == false) {
      this.clearAuthStorage()
    }
  }
  clearAuthStorage(){
    localStorage.removeItem('currentUser');
    localStorage.removeItem('card_verified');
    localStorage.removeItem('cardSelected');
    localStorage.removeItem('uC');
    localStorage.removeItem('uCs');
    localStorage.removeItem('redirectData');
    localStorage.removeItem('headerLogin');
    localStorage.removeItem('thebin');
    localStorage.removeItem('selectedCardType');
    localStorage.removeItem('isJaToken');
  }
  getCards() {
    // var userCards = JSON.parse(localStorage.getItem("uCs"));
    // if(userCards && userCards.length > 0){
    //   this.userCards = userCards;
    //   this.checkSelectedCard();
    // }
    // else{
    const api = this.GlobalConstants.client === 'smeoffers' ? this._apiService.getCardsbyProject() : this._apiService.getCards();
    api.subscribe(
      (res: any) => {
        this.userCards = res.data;
        const userCards = res.data.map((card) => {
            const cardIdObj = {id: card.id};
          return cardIdObj
        })
        localStorage.setItem("uCs", JSON.stringify(userCards));
        this.dataTransferService.nextUserCards(res.data);
        this.checkSelectedCard();
      },
      (err) => {

      }
    );
    // }
  }
  checkSelectedCard(){
    if (localStorage.getItem('uC') && localStorage.getItem('uC') != 'undefined') {
      let usercard = JSON.parse(localStorage.getItem('uC'));
      this.currentUserCard = usercard;
      this.userCards.forEach((x) => {
        if (this.currentUserCard.id && (x.id == this.currentUserCard.id)) {
          x['currentCard'] = true;
        } else {
          x['currentCard'] = false;
        }
      });
    }
  }

  checkRedirect(){
    let redirectData = JSON.parse(localStorage.getItem('redirectData'));
    const rederectProject = this.specialProjects.find((x) => { return x.id === redirectData.id })
        if(rederectProject && rederectProject.id){
      localStorage.removeItem('redirectData');
      this.router.navigate([rederectProject.attributes.code, 'offers']);
    }
    else {
      localStorage.removeItem('redirectData');
    }
  }
  reloadInit() {
    this.checkAuth();
    this.reloadTemplate.emit();
  }

  ngDoCheck() {
    if (this.GlobalConstants.data.bin_login && localStorage.getItem("cb")) {
      this.isLoggedIn = true;
    } else {
      if (localStorage.getItem("currentUser")) {
        this.isLoggedIn = true;
      } else {
        this.isLoggedIn = false;
      }
    }
  }

  backClicked() {
    this.location.back();
  }


  login(project?) {
    if(project){
      project['projectId'] = project.id;
      localStorage.setItem('redirectData', JSON.stringify(project));
    }
    else{
      // localStorage.setItem('headerLogin', 'true');
    }
    this.authC.restartLogin();
  }

  hideAuthentication() {
    this.showAuthentication = false;
  }



  logout() {
    this.authenticationService.deleteToken().subscribe((res) => {
      this.authenticationService.logout();
      this.router.navigate(['/']);
      window.location.href = "/";
    }, (error) => {
      this.authenticationService.logout();
      this.router.navigate(['/']);
      window.location.href = "/";
    });
  }

  setCurrentUserCards(card) {
    // localStorage.setItem('uC', JSON.stringify(card));
    this.validateCard(card.attributes.bin, card.attributes.bin_type);
    // window.location.reload();
  }

  validateCard(bin, bin_type) {
    this._apiService.validateCard(bin, bin_type).subscribe(res => {
      if (res && res.data && res.data.attributes.bin == bin && res.data.attributes.status == 'bin_verified') {
        let current_user = JSON.parse(localStorage.getItem("currentUser"));
        current_user.token = res.data.attributes.session_token;
        localStorage.setItem('currentUser', JSON.stringify(current_user));
        this.authenticationService.updateCurrentUser(current_user);
        localStorage.setItem('card_verified', "true");
        const cardObj = JSON.stringify({
          id: res.data.id,
          attributes: {
            display_name: res.data.attributes.display_name
          }
        })
        localStorage.setItem('uC', cardObj);
        this.subscriptions.push(this.dataTransferService.userCard$.subscribe(response => {
        if(response && response.id == res.data.id){
            return
          } else {
            this.dataTransferService.nextUserCard(res.data);
          }
        }))
        // location.reload();
        location.href = '';
      }
      else {
        localStorage.setItem('card_verified', "false");
      }
    })
  }

  headerTimeout: any;
  ngOnChanges(change) {



  }

  projects:any;
  specialProjects = [];
  specialProjectsDisp = [];
  message:any;
  hasSpecial = false;
  getProjects() {
    if(this.GlobalConstants.client !== 'smeoffers') {
      this._apiService.getProjects().subscribe(
        (res: any) => {
          if(res.data && res.data.length > 1){
            this.hasSpecial = true;
          }
        },
        (err) => {
          this.toastr.error($localize`Something went wrong!`,'', {
            timeOut: 6000,
          });
        }
      );
    }
  }

  resetShowProfileDropDown() {
    this.hideProfileDropDown.emit(false);
  }

  openSearchModal() {
    const initialState = {
      features: ['All Offers', 'Offers Near Me']
    }
    var config = {
      backdrop: true,
      ignoreBackdropClick: false
    };
    this.modalRef = this.modalService.show(SearchComponent, Object.assign({}, config, { initialState }));
    this.modalRef.content.searchItemEvent.subscribe(res => {

    })
    this.modalRef.content.selectedItemEvent.subscribe(res => {
      if (res) {
        this.modalRef.hide();
        const merchant = res.item;
        this.router.navigate(['/offer/offer-details/' + merchant.id + '/all/' + (merchant.attributes.name ? merchant.attributes.name.split(' ').join('-').split(',').join('').split('(').join('').split(')').join('').toLowerCase() : '')]);
      }
    })
    this.modalRef.content.hideEvent.subscribe(res => {
      if (res) { this.modalRef.hide(); }
    })
  }

  getMerchants(name) {

  }

  openAddcardModal() {
    if (this.locale !== 'ja' && this.userCountry?.attributes?.iso2_code !== 'JP') {
      var config = {
        backdrop: true,
        ignoreBackdropClick: false,
        class: 'modal-dialog-centered'
      };
      this.modalRef = this.modalService.show(AddCardModalComponent, Object.assign({}, config, { }));
      this.modalRef.content.hideEvent.subscribe(res => {
        if (res) { this.modalRef.hide(); }
      })
    } else {
      this.logout()
    }
  }

  //international logic starts
  showLocationError:any;
  userLocation: any;
  userCountry: any;
  allInternationalCountries = [];
  allCountries:any;

  getAllInternationalCountries(checkLocation = true, openLocationModal = false) {
    let allCountries = JSON.parse(localStorage.getItem("allCountries"));
    if (!allCountries || allCountries.length == 0) {
      this._apiService.getAllCountries().subscribe(
        (res: any) => {
          this.allInternationalCountries = res.data;
          this.processInternationalCountries(checkLocation, openLocationModal)
        });
    }
    else{
      this.allInternationalCountries = allCountries;
      this.processInternationalCountries(checkLocation, openLocationModal)
    }
    
  }
  private processInternationalCountries(checkLocation, openLocationModal){
    
    this.allInternationalCountries.sort(function (a, b) {
      var textA = a.attributes.name.toUpperCase();
      var textB = b.attributes.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    this.dataTransferService.nextCountries(this.allInternationalCountries)
    if (checkLocation) {
      this.checkLocation();
    }
    if (openLocationModal) {
      this.showLocationModal();
    }
  }

  getInternationalGeoLocation() {
    if (
      !localStorage.getItem("userCountry") ||
      (this.GlobalConstants.client === "smeoffers" && this.locale === "ja")
    ) {
      if (
        !this.allInternationalCountries ||
        (this.allInternationalCountries &&
          this.allInternationalCountries.length < 2)
      ) {
        this.getAllInternationalCountries();
      } else {
        this.checkLocation();
      }
    } else {
      this.getProjects();
    }
  }

  checkLocation() {
    if (localStorage.getItem("userLocation")) {
      this.userLocation = JSON.parse(localStorage.getItem("userLocation"));
      if (this?.locale !== 'ja') {
        this.checkCordinates(this.userLocation.latitude + ',' + this.userLocation.longitude);
      } else {
        this.checkJapanLocale();
      }
    }
    else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.userLocation = position.coords;
        localStorage.setItem("userLocation", JSON.stringify({ latitude: position.coords.latitude, longitude: position.coords.longitude }));
        this.checkCordinates(this.userLocation.latitude + ',' + this.userLocation.longitude);
      }, () => {
        if (this?.locale !== 'ja') {
          this.showLocationModal(false);
        } else {
          this.checkJapanLocale();
        }
      });
    } else {
      this.showLocationModal(false);
    }
  }

  checkCordinates(param) {
    this._apiService.checkCordinates(param).subscribe(
      (res: any) => {
        if (res && res.results[0] && res.results[0].components) {
          let county;
          let country = res.results[0].components.country.toLowerCase();
          if (res.results[0].components.county) {
            county = res.results[0].components.county.toLowerCase();
          }
          else if (res.results[0].components.county) {
            county = res.results[0].components.city.toLowerCase();
          }
          else if (res.results[0].components.county) {
            county = res.results[0].components.state.toLowerCase();
          }
          this.processInternationalLocation(county, country);
        }
      },
      () => {
        this.showLocationModal(false);
      }
    );
  }
  showLocationModal(allowClose = true){

    const initialState = {
      allCountries: this.allInternationalCountries ? this.allInternationalCountries : null,
      languages: this.languages ? this.languages : null
    }
    var config = {
      backdrop: true,
      ignoreBackdropClick: allowClose ? false : true,
        keyboard : allowClose ? true : false
    };
    this.modalRef = this.modalService.show(CountryModalComponent, Object.assign({}, config, { initialState }));
    this.modalRef.content.hideEvent.subscribe(res => {
      if (res) { this.modalRef.hide(); }
    })


  }
  processInternationalLocation(county, country) {
    this.userCountry = this.allInternationalCountries.find((x) => { return x.attributes.name.toLowerCase() == country })
    if (this.userCountry) {
      this.userCountry = this.userCountry;
      localStorage.setItem("userCountry", JSON.stringify(this.userCountry));
      this.getProjects();
      // location.reload();
      this.dataTransferService.nextReloadEvent(true)
    }
    else {
      this.showLocationModal(false);
    }
  }

  goTo(project,type){
    if(this.isLoggedIn){
      if(type === 'project'){
        if(project && project.attributes && project.attributes.merchant){
          this.router.navigate(['offer',project.attributes.code]);
        }
        else{
          this.router.navigate([project.attributes.code, 'offers']);
        }
      }
      else if(type === 'home'){
        let qParams: Params = {};
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: qParams,
          queryParamsHandling: ''
        });
      }
    }
    else{
      this.login(project);
    }
  }

  debouncedPopulateMerchantList(searchTextValue: any){
    // this.searching = true;
    // this.subject.next(searchTextValue);
  }

  searchSubscription() {
    this.searchControl.valueChanges.pipe(
      debounceTime(400),
      switchMap(term => this.populateMerchantList(term))
    ).subscribe(
      (res: any) => {
        this.merchantList = []
        this.searching = false;
        this.searchLoading = false;
        this.merchantList = res.data;
        this.isSearchDropdownOpen = true;
        if(this.merchantList.length > 0){
          this.showNull = false;
        }
        else{
          this.searching = false;
          this.showNull = true;
        }
      },
      (err) => {
      }
    );
  }

populateMerchantList(term){
    this.searchInput = term;
  var params = {name: term};
  if(this.locationData){
      params['country_id'] = this.locationData.id
    }
    var merchantDiv = document.getElementById('merchant-list');
    this.isSearchDropdownOpen = true;
    // if(term.length > 0){
    this.searchLoading = true;
    return this._apiService.getMerchants(params)
    // }
    // else{
    //   return of(null);
    //   // this.isSearchDropdownOpen = false;
    // }
  }

showSearch(element){
  setTimeout(()=>{ 
      element.focus();
    },0);
  }

  private checkJapanLocale() {
    if (this?.locale === 'ja' && this.userCountry?.attributes?.iso2_code !== "JP") {
      const japanCountryObj = this.allInternationalCountries?.find(country => country?.attributes?.iso2_code === "JP");
      if (japanCountryObj) {
        localStorage.setItem("userCountry", JSON.stringify(japanCountryObj));
        if (japanCountryObj?.attributes?.languages?.length) {
          let resLanguage = japanCountryObj?.attributes?.languages?.find((language: any) => this._detectLocation.availableTranslatedLanguages?.includes(language?.name?.toLowerCase()));
          if (!resLanguage) {
            resLanguage = this.languages.find((language: ILanguage) => language?.attributes?.iso639_1 === 'en')
            resLanguage = resLanguage?.attributes;
          }
          const language: ILanguage = {
            attributes: { ...resLanguage },
            id: resLanguage?.id,
            type: "language"

          }
          this._detectLocation.setLanguage(language, false, true);
        }
      }
    }
  }
}
